import UNAM from '../../../assets/images/sponsors/logo_unam.png';
import CICESE from '../../../assets/images/sponsors/logo_cicese.png';
import UABC from '../../../assets/images/sponsors/uabc.svg';
import CNYN from '../../../assets/images/sponsors/cnyn.jpeg';
import FIAD from '../../../assets/images/sponsors/fiad.svg';
import AMNN from '../../../assets/images/sponsors/AMNN.png';
import NANOTECH from '../../../assets/images/sponsors/NANOTECHCOLOR.svg';
import Ensenada from '../../../assets/images/sponsors/LogosXXVAyuntamiento-2.png';
import Anyhover from '../../../assets/images/sponsors/anyhover.png';

export const Sponsors = () => {
  return (
    <>
      <section className="snn-page-section snn-topics">
        <h2 className="snn-title">Participating institutions</h2>
        <div className="logo-grid logo-grid-primary">
          <div className="logo-tile">
            <img src={UNAM} alt="UNAM" />
          </div>
          <div className="logo-tile">
            <img src={CNYN} alt="CNyN" />
          </div>
          <div className="logo-tile">
            <img src={CICESE} alt="CICESE" />
          </div>
          <div className="logo-tile">
            <img src={UABC} alt="UABC" />
          </div>
        </div>
        <div className="logo-grid logo-grid-secondary">
          <div className="logo-tile logo-tile-secondary">
            <img src={FIAD} alt="FIAD" />
          </div>
          <div className="logo-tile logo-tile-secondary">
            <img src={AMNN} alt="AMNN" />
          </div>
        </div>

        <h2 className="snn-title">Sponsors</h2>
        <div className="logo-grid logo-grid-sponsors">
          <div className="logo-tile logo-tile-sponsor">
            <img src={Ensenada} alt="Ayuntamiento de Ensenada" />
          </div>
          <div className="logo-tile logo-tile-sponsor">
            <img src={Anyhover} alt="Anyhover" />
          </div>
          <div className="logo-tile logo-tile-sponsor">
            <img src={NANOTECH} alt="Nanotech" />
          </div>
        </div>
      </section>
    </>
  );
};
